const DESTINATION_TYPES = [
  {
    label: 'Comercial',
    type: 'COMMERCIAL',
    icon: 'COMMERCIAL'
  },
  {
    label: 'Residencial',
    type: 'RESIDENTIAL',
    icon: 'RESIDENTIAL',
    children: [
      {
        label: 'Prédio',
        icon: 'RESIDENTIAL_BUILDING',
        type: 'RESIDENTIAL_BUILDING'
      },
      {
        label: 'Casa',
        icon: 'HOME',
        type: 'HOUSE'
      }
    ]
  }
];
const DESTINATION_TYPE_QUESTION_TEXT = 'Legal! Esse lugar é:';
const ADDRESS_THRESHOLD_LENGTH_TO_SHOW_FULL_ADDRESS = 48;

export {
  DESTINATION_TYPES,
  DESTINATION_TYPE_QUESTION_TEXT,
  ADDRESS_THRESHOLD_LENGTH_TO_SHOW_FULL_ADDRESS
};
